(() => {
  // app/scripts/main-product-specs.js
  var MainProductSpecs = class extends HTMLElement {
    connectedCallback() {
      if (this._isInitialized)
        return;
      this._isInitialized = true;
      this.breakpointPx = parseInt(this.dataset.breakpoint || "1024", 10);
      this.detailsItems = Array.from(this.querySelectorAll(".specs__item"));
      this.handleResize = () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => this.applyResponsiveMode(), 120);
      };
      this.addEventListener("toggle", (evt) => {
        const toggledDetails = evt.target;
        if (!this.isDesktopViewport() || !this.detailsItems.includes(toggledDetails) || !toggledDetails.open)
          return;
        this.detailsItems.forEach((d) => {
          if (d !== toggledDetails)
            d.open = false;
        });
        this.syncActiveTabButton();
      });
      window.addEventListener("resize", this.handleResize, { passive: true });
      this.applyResponsiveMode();
    }
    disconnectedCallback() {
      window.removeEventListener("resize", this.handleResize);
      this.destroyTabsBar();
      this._isInitialized = false;
    }
    isDesktopViewport() {
      return window.innerWidth >= this.breakpointPx;
    }
    applyResponsiveMode() {
      if (this.isDesktopViewport()) {
        this.ensureOneDetailsOpen();
        if (!this.tabsBarElement)
          this.buildTabsBar();
        this.syncActiveTabButton();
      } else {
        this.destroyTabsBar();
      }
    }
    ensureOneDetailsOpen() {
      if (!this.detailsItems.length)
        return;
      const firstOpen = this.detailsItems.find((d) => d.open) || this.detailsItems[0];
      this.detailsItems.forEach((d) => d.open = d === firstOpen);
    }
    buildTabsBar() {
      const bar = document.createElement("div");
      bar.className = "specs__tabs";
      bar.setAttribute("role", "tablist");
      this.detailsItems.forEach((detailsEl, index) => {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "specs__tab";
        btn.setAttribute("role", "tab");
        btn.dataset.index = String(index);
        btn.textContent = (detailsEl.querySelector(".specs__summary")?.textContent || `Tab ${index + 1}`).trim();
        const summaryText = (detailsEl.querySelector(".specs__summary")?.textContent || `Tab ${index + 1}`).trim();
        btn.textContent = summaryText;
        const specsContent = detailsEl.querySelector(".specs-panel__content");
        let isEmpty = false;
        if (specsContent) {
          isEmpty = specsContent.innerHTML.trim() === "";
        }
        if (isEmpty) {
          btn.classList.add("hidden");
        }
        const firstDetails = this.detailsItems[0];
        const firstContent = firstDetails.querySelector(".specs-panel__content");
        const specsItem = this.querySelector(".specs__item");
        if (!firstContent) {
          const firstTab = bar.querySelector(".specs__tab[data-index='0']");
          if (firstTab)
            firstTab.remove();
          firstDetails.remove();
          specsItem.open = true;
        }
        bar.appendChild(btn);
      });
      bar.addEventListener("click", (evt) => {
        const btn = evt.target.closest(".specs__tab");
        if (!btn)
          return;
        if (btn.disabled)
          return;
        const index = Number(btn.dataset.index);
        this.detailsItems.forEach((d, i) => d.open = i === index);
        this.syncActiveTabButton();
      });
      const visibleTabs = bar.querySelectorAll(".specs__tab:not(.hidden)");
      if (visibleTabs.length === 1) {
        visibleTabs[0].disabled = true;
        visibleTabs[0].setAttribute("aria-disabled", "true");
      }
      this.insertBefore(bar, this.firstChild);
      this.classList.add("has-tabs");
      this.tabsBarElement = bar;
    }
    syncActiveTabButton() {
      if (!this.tabsBarElement)
        return;
      const openIndex = this.detailsItems.findIndex((d) => d.open);
      this.tabsBarElement.querySelectorAll(".specs__tab").forEach((btn, i) => {
        const isSelected = i === openIndex;
        btn.setAttribute("aria-selected", isSelected ? "true" : "false");
        btn.tabIndex = isSelected ? 0 : -1;
      });
    }
    destroyTabsBar() {
      if (this.tabsBarElement)
        this.tabsBarElement.remove();
      this.tabsBarElement = null;
      this.classList.remove("has-tabs");
    }
  };
  if (!customElements.get("main-product-specs")) {
    customElements.define("main-product-specs", MainProductSpecs);
  }
})();
